import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import * as Track from '@project/shared/utils/tracking/js/tracking';
import * as Cookies from 'js-cookie';

const classes = {
	videoEl: 'js-a-video__element',
	videoConsentEl: 'js-a-video-consent__element',
	videoCaption: 'js-a-video__caption',
	videoPlay: 'mi-big-play-cover',
	videoLocked: 'js-a-video__locked',
	videoGatedPlay: 'js-a-video__gated-play',
	videoOpenedBtn: 'js-a-video__opened-btn',
};

let videoDataGlobal: any;

interface IvideoData {
	playerId: string;
	videoId: string;
	embedscript: string;
	flashPath: string;
	apiUrl: string;
	configType: string;
	tId: number;
	usercentricsDpsServiceName: string;
	milestonePercentage: number;
	mktoenvId: string;
	formenvId: string;
}

@createModule('VideoComponent')
/**
 * Video component implementation.
 *
 * @author Lars-Olof Kreim <lars-olof.kreim@namics.com>
 */
export class VideoComponent extends TerrificSpec {
	$ctx: JQuery;
	api: any;
	$videoContainer: JQuery;
	$consentContainer: JQuery;
	videoData: IvideoData;
	videoName: string;
	containerId: string;
	consentContainerId: string;
	progressMarker: number[];
	reachedMarker: number;
	$videoPlay: JQuery;
	$videoLocked: JQuery;
	$videoGatedPlay: JQuery;
	$videoOpenedBtn: JQuery;
	loggedPlayActivity: boolean;
	loggedReachedMilestoneActivity: boolean;
	milestonePercentage: number;
	cdpReportName: string;

	/**
	 * start method, called on terrific bootstap
	 *
	 * @param {Object} resolve  function to call at the end of component start
	 * @returns {void}
	 */
	start(resolve: () => void) {
		this.$ctx = $(this._ctx);
		this.$videoContainer = this.$ctx.find(`.${classes.videoEl}`);
		this.$consentContainer = this.$ctx.find(`.${classes.videoConsentEl}`);
		this.videoData = this.$ctx.data() as IvideoData;
		videoDataGlobal = this.videoData;
		this.milestonePercentage = this.videoData.milestonePercentage;
		this.loggedPlayActivity = false;
		this.loggedReachedMilestoneActivity = false;
		this.addMiScript();
		this.RegisteredUpdate();
		this.cdpReportName = this.$ctx.data('cdp-report-name');
		$("body").addClass(".state-m-navigation--scroll-0-position");

		if (this.videoData.usercentricsDpsServiceName.length > 0) {
			/**
			 * Handle Usercentrics consent changes.
			 */
			(window as any).addEventListener('UC_UI_INITIALIZED', function(e: CustomEvent) {
				const services = (window as any).UC_UI.getServicesBaseInfo() as any[];
				var sc = services.find((s) => s.name === 'eVideo');

				if (sc && sc.consent && sc.consent.status) {
					Cookies.set('evideo_consent_accepted', 'true', { expires: 365 });
					$('.js-a-video-consent__element').hide();
				} else {
					let cookieValue = Cookies.get('evideo_consent_accepted');
					if (cookieValue != undefined) {
						if (cookieValue.length > 0) {
							Cookies.remove('evideo_consent_accepted');
						}
					}
				}
			});

			/**
			 * Handle Usercentrics consent changes. Check for Sitecore Analytics consent.
			 */
			let _this = this;
            (window as any).addEventListener('ucEvent', function(e: CustomEvent) {
                if (e.detail && e.detail.event == 'consent_status') {
                    const dpsName = 'eVideo';
                    if (e.detail[dpsName] === true) {
                        $('.js-a-video-consent__element').hide();
                        if ((window as any).VideoPlayer != undefined) {
                            (window as any).VideoPlayer.Collection.acceptAnalytics();
                            _this.onScriptLoaded(_this.containerId);
                        }
                    } else {
                        if ((window as any).VideoPlayer != undefined) {
                            (window as any).VideoPlayer.Collection.rejectAnalytics();
                        }
                    }
                }
            });
		}

		resolve();
	}
	
	/**
	 * method is called to initialize MiScript
	 *
	 * @returns {void}
	 */
	addMiScript() {
		this.containerId = `a-video__mi-player-${this.videoData.tId}`;
		this.consentContainerId = `e-video-container-${this.videoData.tId}`;
		this.$videoContainer.attr('id', this.containerId);
		this.$consentContainer.attr('id', this.consentContainerId);
		let cookieValue = Cookies.get('evideo_consent_accepted');
		const $script =
			this.videoData.usercentricsDpsServiceName.length > 0 && (cookieValue == undefined || cookieValue == 'false')
				? $(
					`<script type="text/plain" data-usercentrics="${this.videoData.usercentricsDpsServiceName
					}"></script>`
				)
				: $(`<script type="text/javascript"></script>`);
		$script.attr('onload', () => {
			this.onScriptLoaded(this.containerId);
		});
		$script.attr('src', this.videoData.embedscript);
		$(document.body).append($script);
	}

	/**
	 * method is called when script was loaded
	 *
	 * @param {string} id  id of videoplayer container
	 * @returns {void}
	 */
	onScriptLoaded(id: string) {
        if ((window as any).UC_UI_INITIALIZED) {
            if (this.videoData.usercentricsDpsServiceName.length > 0) {
                let cookieValueUC = Cookies.get('evideo_consent_accepted');
                if (cookieValueUC == undefined) {
                    return;
                } else {
                    if ((window as any).VideoPlayer) {
                        setTimeout(() => {
                            const services = (window as any).UC_UI.getServicesBaseInfo() as any[];
                                                var sc = services.find((s) => s.name === 'eVideo');
                                                if (sc && sc.consent && sc.consent.status) {
                                                    Cookies.set('evideo_consent_accepted', 'true', { expires: 365 });
                                                    $('.js-a-video-consent__element').hide();
													this.initVideoPlayer(id);
                                                }
                        }, 1000);
 
                        if (window.location.href.indexOf('#vc_') > -1) {
                            var containerId = window.location.href.split('#')[1];
                            var videoContainer = $('#' + containerId);
                            if (videoContainer !== undefined) {
                                $('html, body').animate(
                                    {
                                        scrollTop: $('#' + containerId).offset().top,
                                    },
                                    1000,
                                    () => {
                                        $('body').addClass('state-m-navigation--scroll-0-position');
                                    }
                                );
                            }
                        }
                    } else {
                        setTimeout(() => {
                            this.onScriptLoaded(id);
                        }, 500);
                    }
                }
            }
        } else {
            // Hack to be sure the videoplayer script was loaded
            if ((window as any).VideoPlayer) {
                setTimeout(() => {
                    const services = (window as any).UC_UI.getServicesBaseInfo() as any[];
                                        var sc = services.find((s) => s.name === 'eVideo');
                                        if (sc && sc.consent && sc.consent.status) {
                                            Cookies.set('evideo_consent_accepted', 'true', { expires: 365 });
                                            $('.js-a-video-consent__element').hide();
											this.initVideoPlayer(id);
                                        }
                }, 1000);
 
                if (window.location.href.indexOf('#vc_') > -1) {
                    var containerId = window.location.href.split('#')[1];
                    var videoContainer = $('#' + containerId);
                    if (videoContainer !== undefined) {
                        $('html, body').animate(
                            {
                                scrollTop: $('#' + containerId).offset().top,
                            },
                            1000,
                            () => {
                                $('body').addClass('state-m-navigation--scroll-0-position');
                            }
                        );
                    }
                }
            } else {
                setTimeout(() => {
                    this.onScriptLoaded(id);
                }, 500);
            }
        }
    }

	/**
	 * method initializes movingimage video player
	 *
	 * @param {string} id  id of videoplayer container
	 * @returns {void}
	 */
	initVideoPlayer(id: string) {
		const config: {
			success: () => void;
			parameters: { configType: string; playerId: string; videoId: string; apiUrl: string; flashPath: string };
		} = {
			success: this.onPlayerInit.bind(this),
			parameters: {
				configType: this.videoData.configType,
				playerId: this.videoData.playerId,
				videoId: this.videoData.videoId,
				apiUrl: this.videoData.apiUrl,
				flashPath: this.videoData.flashPath,
			},
		};
		(window as any).VideoPlayer.Collection.addPlayerById(this.containerId, config);
	}

	/**
	 * method is called when player was initialized
	 *
	 * @param {object} api  player api
	 * @returns {void}
	 */
	onPlayerInit(api: object) {
		this.progressMarker = [25, 50, 75];
		this.reachedMarker = 0;
		this.api = api;
		this.loggedPlayActivity = false;
		this.loggedReachedMilestoneActivity = false;
		this.videoName = this.getVideoName();
		this.api.registerEventListener('play', this.onPlay.bind(this));
		this.api.registerEventListener('pause', this.onPause.bind(this));
		this.api.registerEventListener('ended', this.onEnded.bind(this));
		this.api.registerEventListener('timeupdate', this.onTimeUpdate.bind(this));
		this.api.registerEventListener('timeupdate', this.timeUpdateCallBack.bind(this));
		this.api.registerEventListener('playing', this.playingCallback.bind(this));
	}

	/**
	 * method trys to readout videoname and retuns best match
	 *
	 * @returns {void}
	 */
	getVideoName() {
		const metaApi: any = this.api.getApi('metaData');

		if (metaApi) {
			const metaTitle: string = metaApi.getVideoTitle();
			if (metaTitle) {
				return metaTitle;
			}
		}
		const label: string = this.$ctx.find(`.${classes.videoCaption}`).text() || '';
		if (label.length) {
			return label;
		}
		return 'noName';
	}

	//Create a ClickLink Munchkin Activity when play is pressed
	playingCallback() {
		if (this.loggedPlayActivity == false) {
			(window as any).Munchkin.init(this.videoData.mktoenvId);
			(window as any).Munchkin.munchkinFunction('clickLink', {
				href: '/VideoPlayed-' + this.videoData.videoId + '/?action=Pressed_Play',
			});

			if ((window as any).CDP !== undefined) {
				(window as any).CDP.report(this.cdpReportName, {
					cov_page_url: window.location.href,
					cov_query_param: window.location.search,
					cov_referrel_url: document.referrer,
					cov_campaign_id: '',
					cov_web_act_type: 'Click Video on Webpage',
					cov_file_name: this.videoName,
					cov_video_action: 'VideoPlayed',
					cov_primary_attribute: this.videoData.videoId,
				});
			}

			this.loggedPlayActivity = true;
		}
	}

	//Create a ClickLink Munchkin Activity when the milestone is passed
	timeUpdateCallBack() {
		if (
			this.loggedReachedMilestoneActivity == false &&
			this.milestoneInSeconds() <
			(window as any).VideoPlayer.Collection.getPlayerById(this.containerId).getCurrentTime()
		) {
			var percentWatched = this.milestonePercentage + 'percent';
			(window as any).Munchkin.munchkinFunction('clickLink', {
				href:
					'/VideoWatched-' +
					percentWatched +
					'-' +
					this.videoData.videoId +
					'/?action=Milestone_Reached-' +
					percentWatched,
			});

			if ((window as any).CDP !== undefined) {
				(window as any).CDP.report(this.cdpReportName, {
					cov_page_url: window.location.href,
					cov_query_param: window.location.search,
					cov_referrel_url: document.referrer,
					cov_campaign_id: '',
					cov_web_act_type: 'Click Video on Webpage',
					cov_file_name: this.videoName,
					cov_video_action: 'VideoWatched-' + percentWatched,
					cov_primary_attribute: this.videoData.videoId,
				});
			}

			this.loggedReachedMilestoneActivity = true;
		}
	}

	//function to convert percentage to a number of seconds through loaded video
	milestoneInSeconds() {
		//event.target is undefined, that is a bug that moving image should fix
		//that's the reason we need to fetch the video player again
		var milestonePercentageAsDecimal = this.milestonePercentage / 100;
		return (
			milestonePercentageAsDecimal *
			(window as any).VideoPlayer.Collection.getPlayerById(this.containerId).getDuration()
		);
	}

	/**
	 * method is called when player starts to play
	 *
	 * @returns {void}
	 */
	onPlay() {
		this.track('Played');
	}

	/**
	 * method is called when player pauses
	 *
	 * @param {object} e  event
	 * @returns {void}
	 */
	onPause(e: { time: number }) {
		const currentTime = Math.round(e.time);
		if (currentTime < Math.floor(this.api.getDuration())) {
			this.track('Paused', `${currentTime}`);
		}
	}

	/**
	 * method is called when player ends
	 *
	 * @returns {void}
	 */
	onEnded() {
		this.track('100%');
		if ((window as any).CDP !== undefined) {
			(window as any).CDP.report(this.cdpReportName, {
				cov_page_url: window.location.href,
				cov_query_param: window.location.search,
				cov_referrel_url: document.referrer,
				cov_campaign_id: '',
				cov_web_act_type: 'Click Video on Webpage',
				cov_file_name: this.videoName,
				cov_video_action: 'VideoWatched-' + '100percent',
				cov_primary_attribute: this.videoData.videoId,
			});
		}
	}

	/**
	 * method is called when player time gets updated
	 *
	 * @param {object} e  event
	 * @returns {void}
	 */
	onTimeUpdate(e: { time: number }) {
		const percentPosition: number = Math.floor((100 * Math.round(e.time)) / this.api.getDuration());
		for (let i: number = 0; i < this.progressMarker.length; i++) {
			const marker = this.progressMarker[i];
			if (percentPosition >= marker && marker > this.reachedMarker) {
				this.reachedMarker = marker;
				this.track(`${marker}%`);
			}
		}
	}

	/**
	 * method tracks event
	 *
	 * @param {string} action  tracking action name
	 * @param {string} value   tracking value
	 * @returns {void}
	 */
	track(action: string, value?: string) {
		const trackdata: {
			event: string;
			eventCategory: string;
			eventAction: string;
			eventLabel: string;
			eventValue?: string;
		} = {
			event: 'video',
			eventCategory: 'Video',
			eventAction: action,
			eventLabel: `${this.videoData.videoId}|${this.videoName}`,
		};
		if (value) {
			trackdata.eventValue = value;
		}
		Track.gtmTrack(trackdata);
	}

	RegisteredUpdate() {
		this.$videoGatedPlay = this.$ctx.find(`.${classes.videoGatedPlay}`);
		this.$videoOpenedBtn = this.$ctx.find(`.${classes.videoOpenedBtn}`);
		if (Track.isKnownMarketoLead()) {
			this.$ctx.removeClass('a-video--locked');
			this.$videoGatedPlay.on('click', this.triggerPlay.bind(this));
			this.$videoOpenedBtn.on('click', this.triggerPlay.bind(this));
		}

		if (Track.isKnownCdcLead()) {
			this.$ctx.removeClass('a-video--locked');
			this.$videoGatedPlay.on('click', this.triggerPlay.bind(this));
			this.$videoOpenedBtn.on('click', this.triggerPlay.bind(this));
		}
	}
	triggerPlay() {
		this.$videoPlay = this.$ctx.find(`.${classes.videoPlay}`);
		this.$videoLocked = this.$ctx.find(`.${classes.videoLocked}`);
		this.$videoPlay.trigger('click');
		this.$videoLocked.remove();
	}
	/**
	 * stop method, called on terrific stop
	 *
	 * @returns {void}
	 */
	stop() {
		try {
			(window as any).VideoPlayer.Collection.removePlayerById(this.containerId);
		} catch (e) {
			// Intentionaly Empty
		}
	}
}
